<template>
  <div class="container">
    <div :class="['refresh-box', (!companyInfo.refreshEnable || loading)?'enable':'']" @click="(!companyInfo.refreshEnable || loading)?()=>{}:onRefresh()">

      <!-- <el-button class="refresh-btn" icon="el-icon-refresh" type="text" :loading="loading" size="mini" :disabled="!companyInfo.refreshEnable" @click="onRefresh"></el-button> -->

        <img class="load" src="@/assets/newicons/shauxin.png" alt="" v-if="!loading">
        <img class="load xuanzhuan001" src="@/assets/newicons/ib02.png" alt="" v-else>
      <span v-if="loading" class="refresh-tip">数据更新中...</span>
      <span v-else class="refresh-tip">{{_updateTime}}</span>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import moment from 'moment'
import { companySubmitH, getCompanyInfo } from '../api/index'
import { mapState} from 'vuex'

export default {
  props: {
    companyName: {
      type: String
    },
    hid:{
      type:String
    },
    disabled: {
      type: Boolean,
      default: false
    },
    updateTime: {
      default: ''
    }
  },
  data () {
    return {
      reportHistoryList: [],
      companyInfo: {
        updateTime: '',
        updateTimeCN: '--',
        refreshEnable: false
      },
      loading: false // 更新中
    }
  },
  computed: {
    ...mapState({
      staffInfo:state => state.user.staffInfo
    }),
    _updateTime () {
      if (!this.companyInfo.updateTime) return '--'
      // const FORMAT = 'YYYY-MM-DD'
      // const now = moment().format(FORMAT) + ' 23:59:59'
      const updateTime = moment(this.companyInfo.updateTime)
      if (updateTime.isAfter(moment().endOf('d').subtract(1, 'd'))) return '今日已更新'
      if (updateTime.isAfter(moment().endOf('d').subtract(7, 'd'))) return '近7天已更新'
      if (updateTime.isAfter(moment().endOf('d').subtract(30, 'd'))) return '近30天已更新'
      if (updateTime.isAfter(moment().endOf('d').subtract(90, 'd'))) return '近90天已更新'
      return '更新时间: 三个月前'
    }
  },
  mounted () {
    this.getCompanyInfo()
  },
  methods: {
    async onRefresh () {
       // 是否是演示账号
      if(this.staffInfo.demonstrationTag == 1){
         this.$message({
                message: '演示账号，无法使用此功能',
                type: 'error'
              });
          return false
      }
      this.loading = true
      const res = await companySubmitH({ companyName: this.companyName,hid:this.companyInfo.hid, optType: 2 })
      if (res.code !== 200) return
      this.reportHistoryList.push(this.companyName)
      this.$message.success('数据更新中，所需时长2分钟，请稍后查看')
      setTimeout(() => {
        this.getCompanyInfo()
      }, 2 * 60 * 1000)
      // this.getCompanySubmitResult()
    },
    getCompanyInfo () {
      // 测试可用
      // '龙泉市冠修医疗器械经营部' 金华贝诺汽车服务有限公司
      // this.companyName = '金华贝诺汽车服务有限公司'
      getCompanyInfo({ companyName: this.companyName ,hid:this.hid}).then((res) => {
        if (res.code !== 200) return
        // if (this.loading) this.$emit('update')
        this.loading = false
        this.companyInfo = res.data || {}
        this.$emit('setPcinfo', this.companyInfo)
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.container {
  position: relative;
  height: 0;
}
.refresh-box {
  position: absolute;
  top: -21px;
  right: 0;
  text-align: right;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
  .load{
    width: 16px;
    height: 16px;
    margin-top: -2px;
  }
  &.enable{
    cursor: default;
    opacity: .7;
  }
}
.refresh-btn {
  text-align: center;
  padding: 0;
  /deep/ {
    i {
      font-size: 14px;
    }
  }
}
.refresh-btn:not(.is-disabled) {
  color: #3F9FFF;
}
.refresh-tip {
  font-size: 13px;
  font-weight: 400;
  color: #999999;
  line-height: 1;
  // cursor: default;
}
.refresh-lalal{

  img{
    width: 16px;
    height: 16px;
  }
}
</style>
